import AppBar from "components/Layout/AppBar";
import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import ClearingIcon from "assets/img/Clearing.svg";
import CleaningIcon from "assets/img/Cleaning.svg";
import StumpRemoval from "assets/img/StumpRemoval.png";
import Labour from "assets/img/Labour.svg";
import DatePicker, { registerLocale } from "react-datepicker";
import "components/Layout/style.css";
import fr from "date-fns/locale/fr"; // the locale you want
registerLocale("fr", fr);
import Checkbox from "@mui/material/Checkbox";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const ReportCalendar = () => {
  const [startDate, setStartDate] = useState(new Date());
  return (
    <div className="pt-4">
      <AppBar />
      <div className="w-full sm:max-w-screen-2xl sm:px-6 mx-auto flex flex-col PlanifiActuel">
        <div className="flex boxxs">
          <div className="Activité">
            <div className="headtitle">Activité</div>
            <div className="tabs">
              <ul>
                <li>
                  <div className="Défrichageimg">
                    <img src={ClearingIcon}></img>
                  </div>
                  <div className="Défrichage">Défrichage</div>
                </li>
                <li>
                  <div className="Défrichageimg">
                    <img src={CleaningIcon}></img>
                  </div>
                  <div className="Défrichage">Nettoyage</div>
                </li>
                <li>
                  <div className="Défrichageimg">
                    <img src={StumpRemoval}></img>
                  </div>
                  <div className="Défrichage">Essouchage</div>
                </li>
                <li>
                  <div className="Défrichageimg">
                    <img src={Labour}></img>
                  </div>
                  <div className="Défrichage">Labour</div>
                </li>
              </ul>
            </div>
          </div>
          <div className="Planifié">
            <div className="Planifiéone">Planifié vs Actuel</div>
            <div className="tabs">
              <ul>
                <li>
                  <div className="Défrichageimg"> Planifié</div>
                  <div className="Défrichage">Actuel</div>
                </li>
                <li>
                  <div className="Défrichageimg"> Planifié</div>
                  <div className="Défrichage">Actuel</div>
                </li>
                <li>
                  <div className="Défrichageimg"> Planifié</div>
                  <div className="Défrichage">Actuel</div>
                </li>
                <li>
                  <div className="Défrichageimg"> Planifié</div>
                  <div className="Défrichage">Actuel</div>
                </li>
              </ul>
            </div>
          </div>
          <div className="claenderweekss">
            <Box className="calenderWeek">
              <DatePicker
                selected={startDate}
                onMonthChange={(date) => setStartDate(date)}
                // showYearDropdown
                // onChange={(date) => setStartDate(date)}
                monthsShown={5}
                locale="fr"
                inline
              />
              <div className="">
                <div className="onebox flex">
                  <div className="name">
                    <div className="calender">
                      <ul>
                        <li>S1</li>
                        <li>S2</li>
                        <li>S3</li>
                        <li>S4</li>
                      </ul>
                      <ul>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="name">
                    <div className="calender">
                      <ul>
                        <li>S1</li>
                        <li>S2</li>
                        <li>S3</li>
                        <li>S4</li>
                      </ul>
                      <ul>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="name">
                    <div className="calender">
                      <ul>
                        <li>S1</li>
                        <li>S2</li>
                        <li>S3</li>
                        <li>S4</li>
                      </ul>
                      <ul>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="name">
                    <div className="calender">
                      <ul>
                        <li>S1</li>
                        <li>S2</li>
                        <li>S3</li>
                        <li>S4</li>
                      </ul>
                      <ul>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="name">
                    <div className="calender">
                      <ul>
                        <li>S1</li>
                        <li>S2</li>
                        <li>S3</li>
                        <li>S4</li>
                      </ul>
                      <ul>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="onebox flex">
                  <div className="name">
                    <div className="calender">
                      <ul>
                        <li>S1</li>
                        <li>S2</li>
                        <li>S3</li>
                        <li>S4</li>
                      </ul>
                      <ul>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="name">
                    <div className="calender">
                      <ul>
                        <li>S1</li>
                        <li>S2</li>
                        <li>S3</li>
                        <li>S4</li>
                      </ul>
                      <ul>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="name">
                    <div className="calender">
                      <ul>
                        <li>S1</li>
                        <li>S2</li>
                        <li>S3</li>
                        <li>S4</li>
                      </ul>
                      <ul>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="name">
                    <div className="calender">
                      <ul>
                        <li>S1</li>
                        <li>S2</li>
                        <li>S3</li>
                        <li>S4</li>
                      </ul>
                      <ul>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="name">
                    <div className="calender">
                      <ul>
                        <li>S1</li>
                        <li>S2</li>
                        <li>S3</li>
                        <li>S4</li>
                      </ul>
                      <ul>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                        <li>
                          {" "}
                          <Checkbox {...label} defaultChecked />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportCalendar;
